/**
 * Created by evgenijsenkevic on 17/2/25
 */

const FriendBalloonTutorial = function () {
    return new TutorialScenario(FriendBalloonTutorial.NAME, {
        listSteps: FriendBalloonTutorial.listSteps,
        isAvailable: function () {
            if (cleverapps.loadedSnapshot) {
                return false;
            }
            return !cleverapps.forces.isShown(Forces.FRIEND_BALLOON) && cleverapps.environment.isMainScene()
                && cleverapps.toolbar.getItem(ToolbarItem.FRIENDS_LIST_REQUESTS.type)
                && cleverapps.user.checkAvailable(cleverapps.config.availables.FRIENDBALLOON)
                && Map2dLocation.currentLocation && Map2d.currentMap.countEmptySlots() > 0 && Map2dLocation.currentLocation.location.locationConfig.isMain;
        }
    });
};

FriendBalloonTutorial.listSteps = function () {
    let pixel, prizeUnit;

    const steps = [{
        onStart: function () {
            const map = Map2d.currentMap;

            const findNearestGroundCell = function (x, y) {
                const grounds = map.listAvailableGrounds();
                let result = null;
                let minDistance = Infinity;
                
                grounds.forEach((cell) => {
                    if (!map.isEmpty(cell.x, cell.y)) {
                        const distance = Math.abs(x - cell.x) + Math.abs(y - cell.y);
                        if (distance < minDistance) {
                            minDistance = distance;
                            result = cell;
                        }
                    }
                });
                
                return result;
            };

            const center = map.scroller.scrollCell;
            const groundCell = findNearestGroundCell(center.x, center.y);

            if (groundCell) {
                const groundCellPosition = Map2d.currentMap.getMapView().alignInGrid(groundCell.x, groundCell.y);
                map.focusOnTarget(groundCellPosition, {
                    allowScrollWithFocus: true,
                    duration: 0.5,
                    callback: () => {
                        this.finish();
                    }
                });
            } else {
                this.finish();
            }
        },
        onFinish: function () {
            Map2dLocation.currentLocation.counter.trigger();
        }
    },
    {
        onStart: function () {
            pixel = Map2dLocation.currentLocation.friendPixelsPlanner.createTutorialPixel();
            pixel.startTutorial(this.finish.bind(this));
        },

        onFinish: function () {
            Map2dLocation.currentLocation.counter.trigger();
        }
    }, {
        onStart: function () {
            Map2d.currentMap.focusOnTarget(pixel.getView(), {
                allowScrollWithFocus: true,
                callback: () => {
                    this.finish();
                }
            });
        },

        onFinish: function () {
            Map2dLocation.currentLocation.counter.trigger();
        }
    }, {
        onStart: function () {
            this.force = cleverapps.forces.create(pixel.getView(), Forces.FRIEND_BALLOON);

            cleverapps.tutorial.on("pixel_collected", (pixelType) => {
                if (pixelType === PixelsSwarm.FRIEND) {
                    this.finish();
                }
            }, this);
        },

        onFinish: function () {
            this.force.hideForceHints();
            Map2dLocation.currentLocation.counter.trigger();
        },

        onCheckConditions: function (options) {
            options = options || {};
            const pixel = options.pixel;
            let result = false;
            if (pixel) {
                result = options.pixel === pixel;
            }
            return result;
        }
    }, {
        onStart: function () {
            if (prizeUnit) {
                prizeUnit.highlight();
                Map2d.currentMap.focusOnUnit(prizeUnit, {
                    allowScrollWithFocus: true,
                    callback: () => {
                        this.finish();
                    }
                });
            } else {
                this.finish();
            }
        },

        onFinish: function () {
            Map2dLocation.currentLocation.counter.trigger();
        }
    }, {
        onStart: function () {
            cleverapps.focusManager.showControlsWhileFocused("toolbar");

            const friendBalloonItem = cleverapps.toolbar.getItem(ToolbarItem.FRIENDS_LIST_REQUESTS.type);

            this.force = cleverapps.forces.create(friendBalloonItem.onGetView(), Forces.FRIEND_BALLOON_SEND_GIFT, {
                importantNodes: [ComponentUtils.findChildByName(cleverapps.Scenes.GetRunningScene(), "toolbar")]
            });
            cleverapps.tutorial.on("send_gift_for_friends", this.finish.bind(this), this);
        },

        onFinish: function () {
            prizeUnit && prizeUnit.unhighlight();
            Map2dLocation.currentLocation.counter.trigger();
        }
    }];

    return steps.map((step) => new TutorialStep(step));
};

FriendBalloonTutorial.NAME = "friendballoontutorial";